// サイドナビ管理
import commonClass from "./commonClass";

export default class sideNaviClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._crtIdx = null;
    this._time = 100;
    this._$area = $('.js-snav_list_hvr_area');
    this._$trg = $('.js-snav_list_hvr_trg');
    this._flgName = 'is-hvr';
    this._navName = '.js-snav';
    this._tgtName = '.js-snav_list_hvr_tgt';
    this._padBtm = 30;
  }

  // 初期化用関数
  _init() {
    var cls = this;

    cls._$area.on('mouseleave', function() {
      cls._crtIdx = null;
    });
    cls._$trg.on('mouseenter', function() {
      cls._enter($(this));
    });
    cls._$trg.on('mouseleave', function() {
      cls._leave($(this));
    });
  }

  // マウスエンター時の処理
  _enter($self) {
    var cls = this;
    var idx = cls._getSelfIdx($self);
    var $tgt = $self.find(cls._tgtName);
    cls._crtIdx = idx;

    setTimeout(function() {
      if (idx === cls._crtIdx && !$self.hasClass(cls._flgName)) {
        $self.addClass(cls._flgName);

        // navは画面高いっぱいまで伸びるため = 画面高として扱う
        var navH = $(cls._navName).outerHeight();
        var tgtH = $tgt.outerHeight();
        var tgtPosBtm = $tgt.offset().top - $(cls._navName).offset().top + tgtH;
        var setPos;

        // ホバーナビの表示位置調整
        if (navH === tgtH) {
          // 画面高さより高い場合（スクロール発生時）
          setPos = (tgtPosBtm - navH) * -1;
        } else if (tgtPosBtm + cls._padBtm > navH) {
          // 通常位置で表示すると下部が見切れる場合（画面高内には収まる）
          setPos = (tgtPosBtm - navH + cls._padBtm) * -1;
        } else {
          // 通常位置
          setPos = 0;
        }

        $tgt.css('top', setPos);
      }
    }, cls._time);
  }

  // マウスリーブ時の処理
  _leave($self) {
    var cls = this;
    var idx = cls._getSelfIdx($self);
    var $tgt = $self.find(cls._tgtName);

    setTimeout(function() {
      if (idx !== cls._crtIdx && $self.hasClass(cls._flgName)) {
        $self.removeClass(cls._flgName);
        $tgt.css('top', 0);
      }
    }, cls._time);
  }

  // 自身のインデックス番号取得
  _getSelfIdx($self) {
    var cls = this;

    return cls._$trg.index($self);
  }
}